export interface ScreenDividerProps {
	childrenLeft: React.ReactNode;
	childrenRight: React.ReactNode;
}

export const ScreenDivider = (props: ScreenDividerProps) => {
	const {
		childrenLeft,
		childrenRight
	} = props;

	return (
		<div className="flex flex-col @md:flex-row gap-12 @md:gap-0">
			<div className="flex-1 @md:border-b">
				{childrenLeft}
			</div>

			<div className="border" />

			<div className="flex-1 @md:border-b">
				{childrenRight}
			</div>
		</div>
	);
};
